import React from "react";
import { Redirect } from "react-router-dom";
const ProtectGuard = (Element) => {
  return (props) => {
    const token = localStorage.getItem("token");

    if (token) {
      return <Redirect to="/dashboard" {...props} />;
    } else {
      return <Element {...props} />;
    }
  };
};

export default ProtectGuard;
